import { IntegrationDataType } from '@mews-commander/data-access';
import { createHandler } from '@mews/std';
import { TextKey } from '@mews-commander/enums';

export const integrationDataTypeTextKeyHandler = createHandler<IntegrationDataType, Mews.TextKey>(
    {
        [IntegrationDataType.CzechPoliceExportIntegration]: TextKey.CzechPoliceExportIntegration,
    },
    TextKey.Integration
);
